import { FC, useState } from "react";

import classes from "./PendingBattle.module.css";
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import axios from "axios";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";
import { TopicModelDocument } from "../votes/Vote";

interface Props {
  battleID: string;
  serverTime: number;
  artworkID: string;
  artworkSrc: string;
  createdAt: Date;
  level: number;
  nextLevelBattle: boolean;
  topic: TopicModelDocument;
}

const timeSince = (serverTime: number, date: number) => {
  var seconds = Math.floor((serverTime - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + "y";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + "m";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + "d";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + "h";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + "m";
  }
  return Math.floor(seconds) + "s";
};

const PendingBattle: FC<Props> = ({
  battleID,
  serverTime,
  artworkID,
  artworkSrc,
  createdAt,
  level,
  nextLevelBattle,
  topic,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  let cancelPrice = 0;
  switch (level) {
    case 1:
      cancelPrice = 10; //nextLevelBattle ? 10 : 10;
      break;
    case 2:
      cancelPrice = 10; //nextLevelBattle ? 15 : 20;
      break;
    case 3:
      cancelPrice = 25; //nextLevelBattle ? 20 : 40;
      break;
    case 4:
      cancelPrice = 50; //nextLevelBattle ? 30 : 70;
      break;
    case 5:
      cancelPrice = 90; //nextLevelBattle ? 45 : 120;
      break;
    case 6:
      cancelPrice = 150; //nextLevelBattle ? 70 : 200;
      break;
    case 7:
      cancelPrice = 250; //nextLevelBattle ? 110 : 400;
      break;
  }
  const [cancelling, setCancelling] = useState(false);
  const cancelBattle = async () => {
    await axios
      .delete(`${API_URL}/battles/${battleID}`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${user.sessionToken}` },
      })
      .then((response) => {
        setCancelling(false);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        setCancelling(false);
      });
  };
  return (
    <>
      <div className={`${classes.votepair} ${classes.isResult}`}>
        <div className={classes.images}>
          <div className={`${classes.img}`}>
            <img src={artworkSrc} alt="" />
          </div>
        </div>

        <div className={classes.results}>
          <div>
            <div className={classes.top}>
              <h2>{topic.title}</h2>
              <div className={classes.date}>
                {timeSince(serverTime, new Date(createdAt).getTime())} ago
              </div>
            </div>
            <div className={classes.rate}>
              <h2>Battle Level</h2>
              <div className={classes.points}>{level}</div>
            </div>
          </div>
          <Button
            secondary={true}
            cancel={true}
            label={`${
              level === 1
                ? `Cancel (+${cancelPrice} 🌕)`
                : `Give Up (+${cancelPrice} 🌕)`
            }`}
            onClick={() => {
              setCancelling(true);
            }}
          />
        </div>
      </div>
      <Modal
        isShown={cancelling}
        setIsShown={setCancelling}
        title="Delete Battle"
        question="Are you sure?"
        btnLabel="Delete"
        btnClick={cancelBattle}
      />
    </>
  );
};

export default PendingBattle;
